<template>
  <div class="mx-8 pb-9">
    <div class="d-flex align-center">
      <h5>New</h5>
      <v-switch v-model="ManualFormType" class="mx-5 mt-4"></v-switch>
    </div>
    <div v-if="ManualFormType">
      <div>
        <h5>General information</h5>
      </div>
      <v-text-field
        placeholder="Title"
        v-model="uploadNewManualForm.title"
        hide-details=""
      ></v-text-field>
      <div class="error--text" v-if="$v.uploadNewManualForm.title.$error">
        Please Enter Title
      </div>
      <v-text-field
        class="mt-3"
        placeholder="Author"
        v-model="uploadNewManualForm.author"
        hide-details=""
      ></v-text-field>
      <div class="error--text" v-if="$v.uploadNewManualForm.author.$error">
        Please Enter Author
      </div>
      <v-select
        class="mt-3"
        :items="language"
        placeholder="Language"
        hide-details=""
        v-model="uploadNewManualForm.Language"
      ></v-select>

      <div class="error--text" v-if="$v.uploadNewManualForm.Language.$error">
        Select Language
      </div>
      <!-- <h5 class="mt-5">File</h5>
      <div class="d-flex align-center">
        <v-btn
          class="text_style mb-4 px-11"
          color="primary"
          outlined
          @click="onButtonClick"
          >Upload File</v-btn
        >

        <input
          ref="uploader"
          class="d-none"
          type="file"
          @change="onFileChanged"
        />
        <div class="d-flex align-center ml-4" style="height: 100%">
          <v-chip
            color="primary"
            @click:close="closechip()"
            class="mt-n4"
            close
            outlined
            v-show="chip1"
            pill
            >{{ this.uploadNewManualForm.UploadedfileName }}</v-chip
          >
        </div>
      </div>
      <div
        class="error--text"
        v-if="$v.uploadNewManualForm.UploadedfileName.$error"
      >
        Please add file
      </div> -->
    </div>
    <div v-if="!ManualFormType">
      <v-autocomplete
        clearable
        placeholder="Add to Existing Manual"
        :items="GetDigitalManuals"
        item-text="Title"
        item-value="Id"
        v-model="uploadNewManualForm.id"
        :error-messages="
          $v.uploadNewManualForm.id.$error ? 'This field is required' : null
        "
      ></v-autocomplete>
      <v-select
        :items="language"
        placeholder="Language"
        hide-details=""
        v-model="uploadNewManualForm.Language"
      ></v-select>
      <div
        class="error--text mt-3"
        v-if="$v.uploadNewManualForm.Language.$error"
      >
        Select Language
      </div>
      <!-- <h5 class="mt-5">File</h5>
      <div class="d-flex align-center">
        <v-btn
          class="text_style mb-4 px-11"
          color="primary"
          outlined
          @click="onButtonClick"
          >Upload File</v-btn
        >
        <input
          ref="uploader"
          class="d-none"
          type="file"
          @change="onFileChanged"
        />
        <div class="d-flex align-center ml-4" style="height: 100%">
          <v-chip
            color="primary"
            @click:close="closechip()"
            class="mt-n4"
            close
            outlined
            v-show="chip1"
            pill
            >{{ this.uploadNewManualForm.UploadedfileName }}</v-chip
          >
        </div>
      </div>
      <div
        class="error--text"
        v-if="$v.uploadNewManualForm.UploadedfileName.$error"
      >
        Please add file
      </div> -->
    </div>
    <h5 class="mt-5">File</h5>
    <div class="d-flex align-center">
      <v-btn
        class="text_style mb-4 px-11"
        color="primary"
        outlined
        @click="onButtonClick"
        >Upload Manual</v-btn
      >
      <input
        ref="uploader"
        class="d-none"
        type="file"
        @change="onFileChanged"
      />
      <div class="d-flex align-center ml-4" style="height: 100%">
        <v-chip
          color="primary"
          @click:close="closechip1()"
          class="mt-n4"
          close
          outlined
          v-show="chip1"
          pill
          >{{ uploadNewManualForm.UploadedfileName }}</v-chip
        >
      </div>
    </div>
    <v-progress-linear
      v-if="uploadNewManualForm.UploadedfileName && uploadProgress < 100"
      :value="uploadProgress"
      color="primary"
      height="10"
      class="mt-2 rounded-xl"
    ></v-progress-linear>
    <div v-if="uploadNewManualForm.UploadedfileName && uploadProgress < 100" class="text-primary text-right">
      {{ uploadProgress }}% 
    </div>
    <div
      class="error--text pb-3"
      v-if="$v.uploadNewManualForm.UploadedfileName.$error"
    >
      Please add file
    </div>
    <div class="d-flex align-center">
      <v-btn
        class="text_style mb-4 px-8"
        color="primary"
        outlined
        @click="onButtonClickThumbnail"
        >Upload Thumbnail</v-btn
      >
      <input
        ref="uploader1"
        class="d-none"
        type="file"
        @change="onFileChangedThumbnail"
      />
      <div class="d-flex align-center ml-4" style="height: 100%">
        <v-chip
          color="primary"
          @click:close="closechip2()"
          class="mt-n4"
          close
          outlined
          v-show="chip2"
          pill
          >{{ this.uploadNewManualForm.UploadedThumbnail }}</v-chip
        >
        <p style="color: #8080808f" v-if="!chip2">(300 x 400 px)</p>
      </div>
    </div>
    <div
    class="error--text pb-3"
    v-if="$v.uploadNewManualForm.UploadedThumbnail.$error"
  >
    Please add image
  </div>
    <!-- <div
      class="error--text"
      v-if="$v.uploadNewManualForm.UploadedThumbnail.$error"
    >
      Please enter thumbnail
    </div> -->
    <div class="d-flex justify-end mx-5">
      <v-btn
        class="px-14 py-6 text_style"
        color="#A1A3A8"
        text
        @click="close()"
      >
        Cancel
      </v-btn>
      <v-btn color="primary" class="px-14 py-6 text_style" :disabled="btnloader" @click="send()">
        <span class="pa-4 text_style" v-if="btnloader != true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          v-else
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  name: "UploadManualComponent",
  computed: {
    ...mapGetters(["GetLoggedInUser", "GetDigitalManuals"]),
  },
  props: ["UploadManual"],
  data() {
    return {
      btnloader: false,
      uploadProgress: 0,
      chip1: false,
      chip2: false,
      isSelecting: false,
      UploadedfileName: "",
      UploadedThumbnail: "",
      ManualFormType: true,
      language: [
        "English",
        "French",
        "German",
        "Japanese",
        "Czech",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      ExistingManualForm: {
        ExistingManual: "",
        language: "",
      },
      uploadNewManualForm: {
        id: null,
        title: "",
        author: "",
        Language: "English",
        UploadedfileName: "",
        UploadedThumbnail: "",
        selectedFile: null,
        Thumbnail: null,
      },
    };
  },
  validations: {
    uploadNewManualForm: {
      title: { required },
      author: { required },
      Language: { required },
      UploadedfileName: { required },
      UploadedThumbnail: { required },
      id: { required },
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },

    send() {
      if (
        this.$v.$invalid &&
        this.ManualFormType &&
        (this.$v.uploadNewManualForm.title.$invalid ||
          this.$v.uploadNewManualForm.author.$invalid ||
          this.$v.uploadNewManualForm.Language.$invalid ||
          this.$v.uploadNewManualForm.UploadedfileName.$invalid ||
          this.$v.uploadNewManualForm.UploadedThumbnail.$invalid)
      ) {
        this.$v.uploadNewManualForm.title.$touch();
        this.$v.uploadNewManualForm.author.$touch();
        this.$v.uploadNewManualForm.Language.$touch();
        this.$v.uploadNewManualForm.UploadedfileName.$touch();
        this.$v.uploadNewManualForm.UploadedThumbnail.$touch();
      } else if (
        !this.ManualFormType &&
        this.$v.$invalid &&
        (this.$v.uploadNewManualForm.UploadedfileName.$invalid ||
          this.$v.uploadNewManualForm.Language.$invalid ||
          this.$v.uploadNewManualForm.id.$invalid ||
          this.$v.uploadNewManualForm.UploadedThumbnail.$invalid)
      ) {
        this.$v.uploadNewManualForm.Language.$touch();
        this.$v.uploadNewManualForm.UploadedfileName.$touch();
        this.$v.uploadNewManualForm.id.$touch();
        this.$v.uploadNewManualForm.UploadedThumbnail.$touch();
        return;
      } else {
        if(this.uploadProgress < 100){
          return;
        }
        this.btnloader = true;
        var form = new FormData();
        form.append("Author", this.uploadNewManualForm.author);
        form.append("Title", this.uploadNewManualForm.title);
        form.append("Language", this.uploadNewManualForm.Language);
        if (this.uploadNewManualForm.filePath) {
          form.append("FilePath", this.uploadNewManualForm.filePath);
          form.append("UploadViaChunk", true);
        } else {
          form.append("File", this.uploadNewManualForm.selectedFile);
        }
        form.append("Thumbnail", this.uploadNewManualForm.Thumbnail);
        if (this.ManualFormType) {
          form.append("Type", 1);
        } else {
          form.append("Type", 2);
          form.append("Id", this.uploadNewManualForm.id);
        }

        form.append("UserId", this.GetLoggedInUser.Id);
        this.$store.dispatch("CreateDigitalManual", form).then((res) => {
          console.log(res);
          this.btnloader = false;
          this.close();
          if(!res.Status){
            this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: res.Message,
            showConfirmButton: false,
            timer: 5000,
          });
          }
          else{
            this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Manual has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          }
          
          this.uploadNewManualForm.author = "";
          this.uploadNewManualForm.title = "";
          this.uploadNewManualForm.Language = "";
          this.uploadNewManualForm.UploadedfileName = null;
          this.uploadNewManualForm.selectedFile = null;
          this.uploadNewManualForm.Thumbnail = null;
          this.uploadNewManualForm.UploadedThumbnail = null;
          this.chip1 = false;
          this.chip2 = false;
          this.$v.$reset();
        });
      }
    },
    closechip1() {
      this.chip1 = false;
      this.uploadNewManualForm.UploadedfileName = ""
      this.uploadProgress = 0;
    },
    closechip2() {
      this.chip2 = false;
      this.uploadNewManualForm.UploadedThumbnail = ""
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    async uploadFileInChunks(file) {
      const chunkSize = 0.3 * 1024 * 1024; // 0.3 MB chunk size
      const guid = this.generateGuid();
      const totalChunks = Math.ceil(file.size / chunkSize);
      const fileName = file.name;
      let filePath = '';

      this.uploadProgress = 0;
      for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
        const start = (chunkNumber - 1) * chunkSize;
        const end = Math.min(chunkNumber * chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("File", chunk);
        formData.append("Guid", guid);
        formData.append("ChunkNumber", chunkNumber.toString());
        formData.append("TotalChunks", totalChunks.toString());
        formData.append("OriginalFileName", fileName);

        try {
          const response = await this.$store.dispatch("UploadChunk", formData);
          this.uploadProgress = Math.round((chunkNumber / totalChunks) * 100);
          
          // On last chunk, we get the complete file path
          if (chunkNumber === totalChunks) {
            filePath = response.Message; 
            this.uploadNewManualForm.filePath = filePath;
            this.uploadProgress = 100;
          }
        } catch (err) {
          console.error("Upload failed at chunk", chunkNumber, err);
          throw err;
        }
      }
      
      return filePath;
    },
    
    generateGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0,
              v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    async onFileChanged(e) {
      const file = e.target.files[0];
      if (!file) return;
      
      this.chip1 = true;
      this.uploadNewManualForm.selectedFile = file;
      this.uploadNewManualForm.UploadedfileName = file.name.substring(0, 32);
      this.$refs.uploader.value = null;
      
      try {
        await this.uploadFileInChunks(file);
      } catch (error) {
        console.error("File upload failed:", error);
        this.chip1 = false;
        this.uploadNewManualForm.UploadedfileName = "";
        this.uploadNewManualForm.selectedFile = null;
      }
    },
    onButtonClickThumbnail() {
      this.$refs.uploader1.click();
    },
    onFileChangedThumbnail(e) {
      this.chip2 = true;
      this.uploadNewManualForm.Thumbnail = e.target.files[0];
      this.uploadNewManualForm.UploadedThumbnail =
        this.uploadNewManualForm.Thumbnail.name.substring(0, 32);
      this.$refs.uploader1.value = null;
    },
  },
};
</script>

<style></style>
